<template>
  <div class="page-with-top-bar">
        <span
          @click="handleBack"
          class="text-blue flex items-center text-[1.1em] font-medium cursor-pointer hover:underline mb-4 mr-8"
          style="user-select: none;"
        >
          <b-icon icon="arrow-left" pack="fas" class="mr-2" />
          {{ activityId ? ($t('back_to') + ' ' + $t('activity')) : ($t('back_to') + ' ' + $t('groups_list')) }}
        </span>
    <section>
      <!-- table -->
      <div class="card p-2">
      <div class="flex items-center justify-between mt-1 mb-1">
      </div>
        <div class="text-lg mb-2">{{ $t('insert_objective_end_date') }}</div>
          

        <form @submit.prevent="renderKPITable()">

        <b-table
          :data="kpiFlattenActivities"
          :loading="loading"

          paginated
          :per-page="50"
          :pagination-simple="true"
          :total="kpiFlattenActivities.length"
          icon-pack="fas"
          class="text-xs border-blue-lighter"
          bordered
          narrowed
          striped
          >

          <template slot="empty">
              <div v-if="! loading" class="m-4 text-lg text-dark-grey">
                <span>{{ $t('empty_activities_table_msg') }}</span>
              </div>
          </template>

          <template>

            <!-- name,  -->
            <b-table-column field="name" :label="$t('name')" width="40%" class="text-left" v-slot="group">
              <template >
                <div class="items-center">
                  {{ group.row.activity.name }}<br>
                  <span class="text-blue font-bold" style="font-size: 9px">
                    {{ group.row.group.name }}
                  </span>
                </div>
              </template>
            </b-table-column>

            <b-table-column field="current_start_date" :label="$t('start_date_label')" width="20%" class="text-left" v-slot="group">
              <template >
                <div class="flex items-center">
                  <span>{{ new Date(group.row.activity.current_start_date).toLocaleDateString('es') }}</span>
                </div>
              </template>
            </b-table-column>

            <b-table-column field="current_end_date" :label="$t('end_date_label')" width="20%" class="text-left" v-slot="group">
              <template >
                <div class="flex items-center">
                  <span>{{ new Date(group.row.activity.current_end_date).toLocaleDateString('es') }}</span>
                </div>
              </template>
            </b-table-column>

            <b-table-column field="objective_end_date" :label="$t('objective_end_date')" width="20%" class="text-left" v-slot="group">
              <template >
                <div class="flex items-center">
                  <span>
                    <b-datepicker
                      icon="calendar"
                      icon-pack="fas"
                      v-model="objectiveEndDates[group.row.activity.id]"
                      :first-day-of-week="parseInt($t('first_day_of_week'))"
                      :date-formatter="date => date ? new Date(date).toLocaleDateString('es-ES', { year: 'numeric', month: '2-digit', day: '2-digit' }) : ''"
                      :default-date="objectiveEndDates[group.row.activity.id] || new Date()"
                      :datetime="false"
                      @input="onObjectiveEndDateChange(group.row.activity.id, $event)"

                    />
                  </span>
                </div>
              </template>
            </b-table-column>

          </template>
        </b-table>
        </form>


        <div class="flex items-center justify-center w-full">
          <v-button icon="table"
            @click="goToKpiTablePage()"
            class="ml-4 mr-4">{{ $t('see_kpi') }}</v-button>

          <v-button icon="chart-bar"
            @click="goToKpiChartsPage()"
            class="ml-4 mr-4">{{ $t('see_charts') }}</v-button>

          <v-button icon="calculator" 
            @click="generateReport()"
            class="ml-4 mr-4">{{ $t('export') }}</v-button>
        </div>

      </div>

    </section>
  </div>
</template>

<script>
  import {mapGetters} from "vuex";
  import axios from 'axios'
  import { format } from 'date-fns'
  import ProjectAdminQuickButtons from '·/components/project-admin-quick-buttons'
  import Multiselect from 'vue-multiselect'

  export default {
    props: {
      groupIds: {
        type: Array,
        required: true
      },
      projectId: {
        type: Number,
        required: true
      },
      activityId: {
        type: [Number, String],
        default: null
      }
    },
    components: {
      ProjectAdminQuickButtons,
      Multiselect,
    },

    computed: {

      ...mapGetters({
        navData: "app/navData",
        mobile: 'device/mobile'
      }),

      groupedData() {
        const grouped = {};
        this.data.forEach(item => {
          if (!grouped[item.group]) {
            grouped[item.group] = { group: item.group, subactivities: [] };
          }
          grouped[item.group].subactivities.push(item);
        });
        return Object.values(grouped);
      },

      _columns: function() {
        // return Object.values(this.columns)
        // Object.keys(myObject).map(key => myObject[key]);
        return Object.entries(this.columns).map(([key, value]) => ({ key, title: this.$t(value.title), visible: value.visible }));
      },

      limitShowColumnsSelect() { // cantidad de columnas visibles seleccionadas a mostrar en el multiselect por defecto  8
        return this.mobile.on_mobile ? 3 : 8
      },
    },


    data: () => ({
      kpiFlattenActivities: [], // array de actividades a mostrar en la tabla (extraidos de dentro de los grupos)
      loading: false,
      objectiveEndDates: {}, // objeto para almacenar las fechas objetivo de cada actividad
    }),


    created() {
      this.getKpiGroups()
    },

    mounted(){
      // this.columnsSelected = this._columns.filter(column => column.visible == true)

    },

    methods: {

    async getKpiGroups() {
        this.loading = true
        this.kpiFlattenActivities = []
        this.objectiveEndDates = {}

        const { data } = await axios.get('/api/v2/project/' + this.projectId + '/kpi-groups', {
          params: {
            group_ids: this.groupIds
          }
        })
        if (data && data.success) {
          data.data.forEach(group => {
            group.activity_objects.forEach(rowActivity => {
              this.kpiFlattenActivities.push({ group, activity: rowActivity })
              this.objectiveEndDates[rowActivity.id] = rowActivity.kpi_objective_end_date
                ? new Date(rowActivity.kpi_objective_end_date)
                : (rowActivity.current_end_date ? new Date(rowActivity.current_end_date) : null)
            })
          })
          this.loading = false
        } else {
          this.$notify.error('error_loading_data')
        }
      },

      async onObjectiveEndDateChange(activityId, newDate) {
        this.objectiveEndDates[activityId] = newDate
        try {
          await axios.patch(
            `/api/v2/activity/${activityId}/kpi-objective-end-date`,
            {
              kpi_objective_end_date: newDate ? format(newDate, 'yyyy-MM-dd') : null
            }
          )
          this.$notify.success('Fecha objetivo guardada')
        } catch (e) {
          this.$notify.error('Error guardando fecha objetivo')
        }
      },

      goToKpiTablePage() {
        this.$emit('showKpiTable', {
          groupIds: this.groupIds,
          projectId: this.projectId,
          activityId: this.activityId,
          objectiveEndDates: this.objectiveEndDates
        });
      },

      goToKpiChartsPage() {
        this.$emit('showKpiCharts', {
          groupIds: this.groupIds,
          projectId: this.projectId,
          activityId: this.activityId,
          objectiveEndDates: this.objectiveEndDates
        });
      },

      async generateReport() {

        const { data } = await axios.get('/api/v2/project/' + this.projectId + '/kpi-report', {
          params: {
            groupIds: this.groupIds,
            objectiveEndDates: this.objectiveEndDates,
          }
        })
        if (data && data.success) {
          this.$notify.success('report_generated')
          window.open(data.data, '_blank')
        } else {
          this.$notify.error('error_export')
        }
      },

      handleBack() {
          this.$emit('backToGroups');
      },


      transformData(dataEntrada){
        // Agrupar datos por group y group_id
        const groupedData1 = dataEntrada.reduce((acc, item) => {
          const { group, group_id, subactivity } = item;

          if (!acc[group]) {
            acc[group] = {
              group: group,
              groupId: group_id,
              subactivities: {}
            };
          }

          if (!acc[group].subactivities[subactivity]) {
            acc[group].subactivities[subactivity] = {
              subactivity: subactivity,
              duration: item.duration,
              start_date: item.start_date,
              end_date: item.end_date,
              days_elapsed: item.days_elapsed,
              ratio_programmed: item.ratio_programmed,
              ratio_actual_daily: item.ratio_actual_daily,
              ratio_actual_week: item.ratio_actual_week,
              end_date_estimated: item.end_date_estimated,
              ratio_objective_subactivity: item.ratio_objective_subactivity,
              assignments: []
            };
          }

          acc[group].subactivities[subactivity].assignments.push({
            assignment: item.assignment,
            projected: item.projected,
            unit: item.unit,
            executed: item.executed,
            progress: item.progress,
            executed_per_day: item.executed_per_day,
            ratio_objective: item.ratio_objective,

          });

          return acc;
        }, {});

        // Convertir el objeto agrupado en un array con la estructura deseada
        const result = Object.keys(groupedData1).map(group => {
          const groupData = groupedData1[group];
          const subactivities = Object.keys(groupData.subactivities).map(subactivity => {
            return groupData.subactivities[subactivity];
          });

          return {
            group: groupData.group,
            groupId: groupData.groupId,
            subactivities: subactivities
          };
        });

        return result;
      },

    }
  };
</script>

<style scoped>
  table {
    width: 100%;
    border-collapse: collapse;
  }

  th, td {
    border: 1px solid black;
    padding: 8px;
    vertical-align: middle;
    font-size: 12px;
  }

  th {
    text-align: center;
    background-color: #5577BB;
    color: white;
  }

  .table-container {
    overflow-x: auto;
  }
</style>
